import _styled from"@emotion/styled";import*as React from"react";import{Spinner as Spin}from"@heroui/react";import NumberLoading from"@wp/src/components/common/NumberLoading";const WaitSpinnerContainer=_styled.div`
  height: var(--full-vh, 100vh);
  display: flex;
  align-items: center;
  justify-content: center;
`;const SpinnerAndChildrenWrapper=_styled.div`
  text-align: center;
  margin: ${({margin})=>margin};
`;const SimpleChildrenContainer=_styled.div`
  padding: 20px;
  display: block;
  color: ${props=>props.theme.colors.blue400};
  white-space: pre-wrap;
  font-size: ${props=>props.size==="lg"?"20px":"16px"};
`;const ChildrenContainer=_styled(SimpleChildrenContainer)`
  width: 300px;
`;const SimpleWaitSpinnerContainer=_styled.div`
  display: flex;
  justify-content: center;
  align-items: center;
  height: 100%;
  margin: ${({margin})=>margin};
  gap: 16px;
  flex-direction: ${({flexDirection})=>flexDirection||"row"}; // row is the default value for flex-direction
`;const ParentCenterSpinnerContainer=_styled.div`
  display: flex;
  justify-content: center;
  align-items: center;
  height: 100%;
  width: 100%;
  gap: 16px;
`;const SpinnerTextContainer=_styled.span`
  display: inline-flex;
  font-weight: 500;
  font-size: ${props=>props.size==="lg"?"20px":props.size==="sm"?"14px":"16px"};
  line-height: 1.1;
  text-align: center;
  color: ${props=>props.theme.colors.blue600};
`;export const Spinner=props=>{const{forPage=false,children,className="",inline=false,centerSpinnerToParent,size,spinnerText,showNumberLoading=true,flexDirection,onlyIcon}=props;let{margin="20px 0px"}=props;const icon=React.createElement(Spin,{size:size});if(onlyIcon){return icon}const spinningTextInfo=spinnerText?React.createElement(SpinnerTextContainer,{size:size},spinnerText,showNumberLoading?React.createElement(NumberLoading,{color:props.numberLoadingColor||"inherit",charLength:3}):null):null;if(forPage){const spinnerWithChildren=React.createElement(WaitSpinnerContainer,{className:className},React.createElement(SpinnerAndChildrenWrapper,{margin:margin},icon,spinningTextInfo,children&&React.createElement(ChildrenContainer,{size:size},children)));return React.createElement("div",null,spinnerWithChildren)}if(centerSpinnerToParent){return React.createElement(ParentCenterSpinnerContainer,null,icon,spinningTextInfo,children&&React.createElement(SimpleChildrenContainer,{size:size},children))}if(inline){margin="0"}return React.createElement(SimpleWaitSpinnerContainer,{margin:margin,flexDirection:flexDirection},icon,spinningTextInfo,children&&React.createElement(SimpleChildrenContainer,{size:size},children))};export default Spinner;